import React, { useState, useEffect } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import ColoumnsHeader from "../../generic/ColoumnsHeader";
import { sortingMethod } from "../../../../../Containers/vendor/DashBoard/DBCosntants";
import { addDays, getDiffBtnDates } from "../../../../utils/dateCalculater";
import { convertRS, handleTickInterval, weeklyDataValue } from "../../utlits";
import NoDataFound from "../../generic/NoDataFound";

export interface IOS_LineChartProps {
  dbData: any;
}

const OS_LineChart: React.FC<IOS_LineChartProps> = (props) => {
  const [apiHit, setApiHit] = useState<any>({
    category: [],
    data: [],
    tickInterval: 0,
  });

  const [disableMenu, setDisableMenu] = useState<boolean>(false);

  const setUpChart = async (sortedApiHit: any) => {
    if (sortedApiHit.length > weeklyDataValue) {
      let firstDate = sortedApiHit ? sortedApiHit[0].key : "";
      let lastDate = sortedApiHit
        ? sortedApiHit[sortedApiHit.length - 1].key
        : "";
      let totalWeeks = await getDiffBtnDates(firstDate, lastDate);
      if (totalWeeks % 1 !== 0) {
        totalWeeks = Math.floor(totalWeeks) + 1;
      }
      let key: Array<string> = [];
      let value: Array<number> = [];
      let getNtHitsPrDay = [...sortedApiHit];

      let dateOne = firstDate;
      for (let i = 0; i <= totalWeeks; i++) {
        // Get first Date and adding seven days of getNtHitsPrDay array
        let seventhDay = await addDays(dateOne, 6);

        // eslint-disable-next-line no-loop-func
        let customData = getNtHitsPrDay.filter((date: any) => {
          return (
            date.key >= moment(dateOne).format("YYYY-MM-DD") &&
            date.key <= moment(seventhDay).format("YYYY-MM-DD")
          );
        });

        if (customData.length > 0) {
          let totalVal: any = 0;
          for (let j = 0; j < customData.length; j++) {
            totalVal += parseInt(customData[j].val);
          }
          value.push(parseInt(totalVal));
        } else {
          if (moment(dateOne).format("YYYY-MM-DD") <= lastDate) {
            value.push(0);
          }
        }
        if (moment(dateOne).format("YYYY-MM-DD") <= lastDate) {
          if (lastDate < moment(seventhDay).format("YYYY-MM-DD")) {
            key.push(`${moment(dateOne).format("YYYY-MM-DD")} to ${lastDate}`);
          } else {
            key.push(
              `${moment(dateOne).format("YYYY-MM-DD")} to ${moment(
                seventhDay
              ).format("YYYY-MM-DD")}`
            );
          }
        }
        dateOne = await addDays(seventhDay, 1);
      }
      let getTickInterval = await handleTickInterval(key.length);

      if (key.length > 0 || value.length > 0) {
        setApiHit({
          category: key,
          data: value,
          tickInterval: getTickInterval,
        });
      }
    } else {
      let key: any = [];
      let value: any = [];
      sortedApiHit.forEach((api: any) => {
        key.push(api.key);
        value.push(parseInt(api.val));
      });
      let getTickInterval = await handleTickInterval(key.length);

      if (key.length > 0 || value.length > 0) {
        setApiHit({
          category: key,
          data: value,
          tickInterval: getTickInterval,
        });
      }
    }
  };

  useEffect(() => {
    if (props.dbData && props.dbData.ntApiHitCountCht.length > 0) {
      setDisableMenu(false);
      let sortedApiHit = sortingMethod(props.dbData.ntApiHitCountCht);
      setUpChart(sortedApiHit);
    } else {
      setDisableMenu(true);
      setApiHit({ category: [], data: [], tickInterval: 0 });
    }
  }, [props.dbData]);

  const options = {
    chart: {
      height: "250px",
      type: "line",
    },
    title: "",
    credits: {
      enabled: false,
    },
    legend: false,
    yAxis: {
      title: "",
      margin: "0",
      padding: "0",
      labels: {
        formatter: function (this: any): any {
          let val = convertRS(this.value, 0);
          return val;
        },
      },
    },

    xAxis: {
      categories: apiHit.category,
      crosshair: true,
      tickInterval: apiHit.tickInterval,
      tickPixelInterval: 100,
      labels: {
        formatter: function (this: any): any {
          if (this.value.includes("to")) {
            let splitVal = this.value.split("to");
            return `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
              splitVal[1]
            ).format("DD MMM 'YY")}`;
          } else {
            this.value = moment(this.value).format("DD MMM 'YY");
            return moment(this.value).format("DD MMM 'YY"); // clean, unformatted number for year
          } // clean, unformatted number for year
        },
      },
    },

    tooltip: {
      formatter: function (this: any): string {
        let tooltipVal = "";

        if (this.x.includes("to")) {
          let splitVal = this.x.split("to");
          tooltipVal = `${moment(splitVal[0]).format("DD MMM 'YY")} - ${moment(
            splitVal[1]
          ).format("DD MMM 'YY")}`;
        } else {
          tooltipVal = moment(this.x).format("DD MMM 'YY");
        }
        return `<p><b>${tooltipVal}</b></p> </br> <b><span style="color:${this.series.color}">${this.series.name}</span> : ${this.y}</b>`;
      },
      borderWidth: 0,
      backgroundColor: "#fff",
      borderRadius: 4,
    },

    plotOptions: {
      series: {
        color: "#1c9ad6",
        label: {
          connectorAllowed: false,
        },
      },
    },

    series: [
      {
        name: "API Hits",
        data: apiHit.data ? apiHit.data : [],
      },
    ],
  };
  return (
    <>
      <ColoumnsHeader
        title={"API Hits"}
        isDownload={false}
        disableMenu={disableMenu}
      />
      {disableMenu ? (
        <NoDataFound />
      ) : (
        <HighchartsReact highcharts={Highcharts} options={options} />
      )}
    </>
  );
};

export default OS_LineChart;
